const PAGINA = 1000; // max_rows de PostgREST

type Resultado<T> = { data: T[] | null; error: unknown };

/**
 * Trae TODAS las filas de una consulta paginando de 1000 en 1000 (PostgREST corta en 1000
 * sin avisar). `fn` recibe (desde, hasta) y debe aplicar `.range(desde, hasta)`.
 */
export async function traerTodo<T>(fn: (desde: number, hasta: number) => PromiseLike<Resultado<T>>): Promise<T[]> {
  const todo: T[] = [];
  for (let desde = 0; ; desde += PAGINA) {
    const { data, error } = await fn(desde, desde + PAGINA - 1);
    if (error) throw error;
    todo.push(...(data ?? []));
    if (!data || data.length < PAGINA) break;
  }
  return todo;
}
